import arrowRight from "../../assets/images/arrow-up-right.png";
const Heading = ({ children }) => {
  return (
    <>
      <div className="main-heading font-[Macoxs]">
        <h1>{children}</h1>
        <div className="main-heading-image">
          <img
            src={arrowRight}
            width={60}
            height={60}
            style={{ objectFit: "contain", height: "auto" }}
            alt="arrow-up-right"
          />
        </div>
      </div>
    </>
  );
};

export default Heading;
